<template>
    <div
        :id="id"
        class="stepper-wrapper"
    >
        <div
            v-for="step in stepsArray"
            :key="step"
            class="step"
            :class="{ active: Number(step) === Number(currentStep) }"
        >
            {{ step }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    currentStep: Number,
    steps: Number,
})

const stepsArray = computed(() => {
    return Array.from({ length: props.steps }, (_, i) => i + 1)
})
</script>

<style lang="sass" scoped>
@import './Stepper.sass'
</style>
